export const setCookie = (cname: string, cvalue: string, exdays: number | Date, domain: string = '') => {
  let expires = '';
  if (exdays) {
    let d = new Date(exdays);
    expires = 'expires=' + d.toUTCString();
  }

  let cookie = cname + '=' + cvalue + ';' + expires + ';path=/;';
  let newCookie = cookie;

  if (domain !== '') newCookie = cookie + 'domain=' + domain;

  // console.log(newCookie);
  document.cookie = newCookie;
};

export const getCookie = (cname: string) => {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);

  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};
